import { ICreateUpdateHighlight, IHighlights } from '@interfaces/highlights/IHighlights'
import { IListPaginated } from '@interfaces/api/IRequestsReturn'
import api from '@services/api/server'
import { IMessage } from '@interfaces/iMessage'

export default class HighlightService {
    public static async list(page: number, perPage = 25, sortBy = 'publicationDate.DESC'): Promise<IListPaginated<IHighlights>> {
        return (await api.get<IListPaginated<IHighlights>>(`/highlights/list?page=${page}&perPage=${perPage}&sortBy=${sortBy}`)).data
    }

    public static async delete(id: number): Promise<IMessage> {
        return (await api.delete<IMessage>(`/highlights/${id}`)).data
    }

    public static async create(values: ICreateUpdateHighlight): Promise<IHighlights> {
        return (await api.post<IHighlights>('/highlights', values)).data
    }

    public static async getOne(id: number): Promise<IHighlights> {
        return (await api.get<IHighlights>(`/highlights/${id}`)).data
    }

    public static async update(id: number, values: ICreateUpdateHighlight): Promise<IHighlights> {
        return (await api.put<IHighlights>(`/highlights/${id}`, values)).data
    }
}
